<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepLaunch',
})
</script>
<template>
  <TlDetailItem :title="title" color="blue">
    <TlDetailField label="发起人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="发起时间">{{ record?.createdAt }}</TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepLaunch">
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
import { computed } from 'vue'
const props = defineProps<{
  record?: any
  isRenew?: boolean
}>()
const title = computed(() => (props.isRenew ? '重新发起' : '发起'))
</script>
